import React from "react";
import bg2 from "../assets/images/bg/4.jpg";

const Card = () => {
  return (
    <div className="p-4">
      <div
        className="relative w-full h-screen bg-cover bg-center rounded-lg overflow-hidden"
        style={{ backgroundImage: `url(${bg2})` }}
      >
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/70 backdrop-brightness-75"></div>

        {/* Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 md:px-10 z-10">
          <h1 className="text-white text-3xl md:text-5xl lg:text-6xl font-bold leading-snug drop-shadow-lg">
            Unlock Your Educational Potential
          </h1>

          <h2 className="text-cyan-300 text-lg md:text-2xl lg:text-3xl font-semibold mt-4 mb-6">
            Empowering Futures Through Education
          </h2>

          <p className="text-gray-200 text-base md:text-lg max-w-2xl leading-relaxed">
            At <span className="text-cyan-300 font-semibold">Sky Global Education</span>, 
            we provide resources and opportunities to help you achieve your academic goals. 
            Whether you're exploring scholarships, study abroad programs, or career development paths — 
            we’re here to guide you every step of the way toward a brighter future.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Card;
